import React from 'react';
import { RotateCcw } from 'lucide-react';

const Refund = () => {
  return (
    <div className="bg-[#FAF6F1] min-h-screen py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-[#E9DFD3]">
        <div className="text-center mb-10">
          <div className="inline-flex p-3 rounded-2xl bg-[#F4E7DA] text-[#2C2416] mb-4">
            <RotateCcw className="w-8 h-8" />
          </div>
          <h1 className="font-serif-display text-4xl md:text-5xl text-[#2C2416]">Return & Replacement Policy</h1>
          <p className="text-sm text-[#7A5C4C] mt-2">Wrap Your Wish • Quality Guaranteed</p>
        </div>

        <div className="prose prose-stone max-w-none text-sm text-[#5C4C43] space-y-8 leading-relaxed">
          <p>
            Thank you for choosing Wrap Your Wish for your corporate and custom gifting needs. Because our products are customized specifically for your brand, we adhere to a strict replacement policy under the terms outlined below.
          </p>

          <div className="border-t border-[#F0E7DA] pt-6">
            <h2 className="font-serif-display text-xl text-[#2C2416] mb-3">1. Customized Goods & Mass Orders</h2>
            <div className="space-y-2">
              <p><strong>No Returns on Mass Orders:</strong> We do not accept returns, cancellations, or issue cash refunds on bulk or mass orders once production has commenced or delivery is complete.</p>
              <p><strong>Final Sale on Branded Items:</strong> Products customized with your company logo or custom artwork cannot be repurposed or resold. Therefore, all customized orders are non-returnable.</p>
            </div>
          </div>

          <div className="border-t border-[#F0E7DA] pt-6">
            <h2 className="font-serif-display text-xl text-[#2C2416] mb-3">2. 15-Day Replacement Guarantee</h2>
            <div className="space-y-3">
              <p>We are committed to delivering quality products. We offer item replacements within 15 days of delivery under the following specific conditions:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Faulty Products:</strong> If any item arrives damaged or non-functional, we will replace the affected units.</li>
                <li><strong>Misprints & Branding Errors:</strong> If there is a defect in the logo printing, engraving, or customization that deviates from your approved proof, we will replace the misprinted items at no extra cost.</li>
              </ul>
              <p className="italic text-[#7A5C4C]">Note: Replacement requests submitted after 15 days from the delivery date will not be eligible.</p>
            </div>
          </div>

          <div className="border-t border-[#F0E7DA] pt-6">
            <h2 className="font-serif-display text-xl text-[#2C2416] mb-3">3. Gadgets & Electronics Warranty</h2>
            <div className="space-y-2">
              <p><strong>Brand Warranty:</strong> All gadgets and electronic items supplied by Wrap Your Wish carry their respective original manufacturer/brand warranty.</p>
              <p><strong>Warranty Claims:</strong> For technical issues or performance defects that occur after the initial 15-day replacement period, claims must be directed to the respective brand's authorized service centers as per their warranty terms.</p>
            </div>
          </div>

          <div className="border-t border-[#F0E7DA] pt-6">
            <h2 className="font-serif-display text-xl text-[#2C2416] mb-3">How to Request a Replacement</h2>
            <div className="space-y-2">
              <p>1. Contact our support team via www.wrapyourwish.com or reach out directly to your assigned account manager within 15 days of receiving your order.</p>
              <p>2. Provide your order details along with clear photos or videos showing the fault or misprint.</p>
              <p>3. Once verified by our team, we will process and ship your replacement items.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refund;
